<template>
  <router-link class="logo" to="/">
    <img :src="$store.state.campaign.logo" class="logo-img" />
  </router-link>
</template>

<script>
export default {
  name: "Logo"
};
</script>

<style lang="scss" scoped>
.logo {
  min-width: 93px;
  max-width: 93px;
  height: 50px;
  display: block;

  @media (min-width: 992px) {
    margin-right: 50px;
  }
}

.logo-img {
  height: 100%;
  width: 100%;
  object-fit: cover;
}

@media (max-width: 768px) {
  .logo-img {
    width: unset;
  }
}
</style>
